// Helper function to get flag image URL - using larger size for better quality
const getFlagUrl = (countryCode) => {
  return `https://flagcdn.com/w80/${countryCode.toLowerCase()}.png`;
};

// Languages data with flags, names and backend multilanguageid
export const languages = [
  // Suggested/Popular Languages
  { id: 1, code: 'EN', flag: getFlagUrl('us'), flagEmoji: '🇺🇸', name: 'English', nativeName: 'English' },
  { id: 9, code: 'DE', flag: getFlagUrl('de'), flagEmoji: '🇩🇪', name: 'Deutsch', nativeName: 'Deutsch' },
  { id: 13, code: 'FR', flag: getFlagUrl('fr'), flagEmoji: '🇫🇷', name: 'French', nativeName: 'Français' },
  { id: 5, code: 'ES', flag: getFlagUrl('es'), flagEmoji: '🇪🇸', name: 'Español', nativeName: 'Español' },
  { id: 25, code: 'PT', flag: getFlagUrl('pt'), flagEmoji: '🇵🇹', name: 'Português', nativeName: 'Português' },
  { id: 3, code: 'AR', flag: getFlagUrl('sa'), flagEmoji: '🇸🇦', name: 'العربية', nativeName: 'العربية' },

  // All Languages (sorted by id)
  { id: 2, code: 'TR', flag: getFlagUrl('tr'), flagEmoji: '🇹🇷', name: 'Türkçe', nativeName: 'Türkçe' },
  { id: 4, code: 'RU', flag: getFlagUrl('ru'), flagEmoji: '🇷🇺', name: 'Русский', nativeName: 'Русский' },
  { id: 6, code: 'BG', flag: getFlagUrl('bg'), flagEmoji: '🇧🇬', name: 'Български', nativeName: 'Български' },
  { id: 7, code: 'CS', flag: getFlagUrl('cz'), flagEmoji: '🇨🇿', name: 'Čeština', nativeName: 'Čeština' },
  { id: 8, code: 'DA', flag: getFlagUrl('dk'), flagEmoji: '🇩🇰', name: 'Dansk', nativeName: 'Dansk' },
  { id: 10, code: 'EL', flag: getFlagUrl('gr'), flagEmoji: '🇬🇷', name: 'Ελληνικά', nativeName: 'Ελληνικά' },
  { id: 11, code: 'ET', flag: getFlagUrl('ee'), flagEmoji: '🇪🇪', name: 'Eesti', nativeName: 'Eesti' },
  { id: 12, code: 'FI', flag: getFlagUrl('fi'), flagEmoji: '🇫🇮', name: 'Suomi', nativeName: 'Suomi' },
  { id: 14, code: 'HE', flag: getFlagUrl('il'), flagEmoji: '🇮🇱', name: 'עברית', nativeName: 'עברית' },
  { id: 15, code: 'HU', flag: getFlagUrl('hu'), flagEmoji: '🇭🇺', name: 'Magyar', nativeName: 'Magyar' },
  { id: 16, code: 'ID', flag: getFlagUrl('id'), flagEmoji: '🇮🇩', name: 'Bahasa Indonesia', nativeName: 'Bahasa Indonesia' },
  { id: 17, code: 'IT', flag: getFlagUrl('it'), flagEmoji: '🇮🇹', name: 'Italiano', nativeName: 'Italiano' },
  { id: 18, code: 'JA', flag: getFlagUrl('jp'), flagEmoji: '🇯🇵', name: '日本語', nativeName: '日本語' },
  { id: 19, code: 'KO', flag: getFlagUrl('kr'), flagEmoji: '🇰🇷', name: '한국어', nativeName: '한국어' },
  { id: 20, code: 'LT', flag: getFlagUrl('lt'), flagEmoji: '🇱🇹', name: 'Lietuvių', nativeName: 'Lietuvių' },
  { id: 21, code: 'LV', flag: getFlagUrl('lv'), flagEmoji: '🇱🇻', name: 'Latviski', nativeName: 'Latviešu' },
  { id: 22, code: 'NB', flag: getFlagUrl('no'), flagEmoji: '🇳🇴', name: 'Norsk Bokmål', nativeName: 'Norsk Bokmål' },
  { id: 23, code: 'NL', flag: getFlagUrl('nl'), flagEmoji: '🇳🇱', name: 'Nederlands', nativeName: 'Nederlands' },
  { id: 24, code: 'PL', flag: getFlagUrl('pl'), flagEmoji: '🇵🇱', name: 'Polski', nativeName: 'Polski' },
  { id: 26, code: 'RO', flag: getFlagUrl('ro'), flagEmoji: '🇷🇴', name: 'Română', nativeName: 'Română' },
  { id: 27, code: 'SK', flag: getFlagUrl('sk'), flagEmoji: '🇸🇰', name: 'Slovenčina', nativeName: 'Slovenčina' },
  { id: 28, code: 'SL', flag: getFlagUrl('si'), flagEmoji: '🇸🇮', name: 'Slovenščina', nativeName: 'Slovenščina' },
  { id: 29, code: 'SV', flag: getFlagUrl('se'), flagEmoji: '🇸🇪', name: 'Svenska', nativeName: 'Svenska' },
  { id: 30, code: 'TH', flag: getFlagUrl('th'), flagEmoji: '🇹🇭', name: 'ภาษาไทย', nativeName: 'ภาษาไทย' },
  { id: 31, code: 'UK', flag: getFlagUrl('ua'), flagEmoji: '🇺🇦', name: 'Українська', nativeName: 'Українська' },
  { id: 32, code: 'VI', flag: getFlagUrl('vn'), flagEmoji: '🇻🇳', name: 'Tiếng Việt', nativeName: 'Tiếng Việt' },
  { id: 33, code: 'ZH', flag: getFlagUrl('cn'), flagEmoji: '🇨🇳', name: '简体中文', nativeName: '简体中文' },
];

// Suggested languages (first 6)
export const suggestedLanguages = languages.slice(0, 6);

// All other languages
export const allLanguages = languages.slice(6);

// Get language by code
export const getLanguageByCode = (code) => {
  return languages.find(lang => lang.code === code) || languages[0];
};

// Get multilanguageid by language code
export const getLanguageId = (code) => {
  const lang = languages.find(l => l.code.toUpperCase() === (code || '').toUpperCase());
  return lang ? lang.id : 1;
};

// Default language
export const defaultLanguage = languages[0];
